module.exports = __webpack_public_path__ + "img/ceo_way_tip_02.c95d96a5.png";